import { Component } from '@angular/core';

@Component({
  selector: 'auto-editor-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: false
})
export class LayoutComponent {}
